import React, { useEffect } from 'react'
import CaraBayar from 'view/Grafik/CaraBayar'
import PelayananHt from './PelayananHt'
import { useState } from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { fetchFlags } from 'view/laporan/DataProvider';
import apiService from 'apiService';
import { Select2Nolabel } from 'view/component/FormFormik';
import Table from 'view/component/Table';
import { showLoading, toast } from 'view/component/Alert';
import { getDistrics } from 'view/portal/DataProvider';

export default function Ds() {
    const [frDate, setfrDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [enDate, setenDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [refFlags, setrefFlags] = useState([]);
    const [flags, setflags] = useState('');
    const [scale, setscale] = useState('');
    const [berkunjung, setberkunjung] = useState(0);
    const [takberkunjung, settakberkunjung] = useState(0);
    const [workArea, setworkArea] = useState([])
    const [area, setarea] = useState([])
    const [loading, setloading] = useState(false)
    const [refKecamatan, setrefKecamatan] = useState([])
    const [kecamatan, setkecamatan] = useState([])
    const [refDesa, setrefDesa] = useState([])

    useEffect(() => {
        getFlags();
        getWorkArea();
        getKecamatan();
    }, [1])

    const getKecamatan = async () => {
        let kec = await getDistrics();
        setrefKecamatan(kec)
    }

    const getVillage = async (id) => {
        let data = await apiService.get("/demograph/districts/find/" + id);
        if (data.code == 200) {
            let desa = data.data.villages.map((data) => ({
                label: data.name,
                value: data.id,
            }))
            setrefDesa([...refDesa, ...desa]);
        }
    };

    useEffect(() => {
        if (kecamatan.length > 0) {
            getVillage(kecamatan[kecamatan.length - 1].value);
        }
    }, [kecamatan.length])

    useEffect(() => {
        console.log(refDesa, 'desa')
    }, [refDesa.length])

    const getFlags = async () => {
        let dt = await fetchFlags();
        setrefFlags(dt);
    }
    const getWorkArea = async () => {
        const work_areas = await apiService.get(`/management/work_areas/read`);
        if (work_areas) {
            setworkArea(work_areas.data)
        } else {
            setworkArea([])
        }
    }

    const getCount = async () => {
        showLoading('Generate Data');
        setloading(true)
        let param = {
            skala: scale,
            start_date: frDate,
            end_date: enDate,
            flags,
            area: area.length > 0 ? area.map(a => { return a.value }).toString() : ''
        }
        let data = await apiService.post('/report/count_pasien_spm', param);
        if (data.code == 200) {
            setberkunjung(data.berkunjung);
            settakberkunjung(data.tidak_berkunjung);
            toast({ status: 'success', text: "data berhasil digenerate" })
        } else {
            setberkunjung(0);
            settakberkunjung(0);
            toast({ status: 'error', text: "data berhasil digenerate" })
        }
        setloading(false)
    }

    return (
        <div>
            <div className="header bg-success">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-center py-4">
                            <div className="col-lg-6 col-7">
                                <h6 className="h2 text-white d-inline-block mb-0">
                                    Dashboard SPM
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-header'>
                <div className='row mb-2'>
                    <div className="col-md-2">
                        <h3>Flags</h3>
                    </div>
                    <select
                        className="form-control col-md-2"
                        value={flags}
                        onChange={(e) => setflags(e.target.value)}
                    >
                        <option value="">Pilih Klinik</option>
                        {refFlags.map(a => (
                            <option value={a.value}>{a.label}</option>
                        ))}
                    </select>
                    <div className="col-md-2">
                        <h3>SKALA</h3>
                    </div>
                    <select
                        className="form-control col-md-2"
                        onChange={(e) => setscale(e.target.value)}
                        value={scale}
                    >
                        <option value="">Pilih skala</option>
                        <option value="1"> "Kunjungan minimal 1 kali"</option>
                        <option value="6"> "DIY (kunjungan >= 6)"</option>
                        <option value="12"> "KEMENKES (kunjungan = 12)" </option>
                    </select>
                </div >
                <div className='row mb-2'>
                    <div className="col-md-2">
                        <h3>AREA</h3>
                    </div>
                    {JSON.parse(localStorage.getItem("userData")).level === 1 ?
                        <>
                            <Select2Nolabel
                                className="basic-multi-select form-control  p-0 pt-1 col-md-4"
                                name="village"
                                onChange={(e) => setkecamatan(e)}
                                value={kecamatan}
                                errors={''}
                                touched={''}
                                icon="ni ni-circle-08"
                                type="text"
                                placeholder={"pilih kecamatan"}
                                option={refKecamatan}
                                isMulti
                            />
                            <Select2Nolabel
                                className="basic-multi-select form-control  p-0 pt-1 col-md-4"
                                name="village"
                                onChange={(e) => setarea(e)}
                                value={area}
                                errors={''}
                                touched={''}
                                icon="ni ni-circle-08"
                                type="text"
                                option={refDesa}
                                isMulti
                            />
                        </>
                        :
                        <Select2Nolabel
                            className="basic-multi-select form-control  p-0 pt-1 col-md-4"
                            name="village"
                            onChange={(e) => setarea(e)}
                            value={area}
                            errors={''}
                            touched={''}
                            icon="ni ni-circle-08"
                            type="text"
                            option={workArea.map((a) => ({
                                label: a.village.name,
                                value: a.village_id,
                            }))}
                            isMulti
                        />
                    }
                </div>
                <div className='row'>
                    <div className="col-md-2">
                        <h3>Tanggal Kunjungan</h3>
                    </div>
                    <DatePicker
                        className="form-control col-md-12"
                        selected={moment(frDate).toDate()}
                        onChange={(date) =>
                            setfrDate(moment(date).format("YYYY-MM-DD"))
                        }
                        value={frDate}
                        dateFormat="yyyy-MM-dd"
                    />
                    <DatePicker
                        className="form-control col-md-12"
                        selected={moment(enDate).toDate()}
                        onChange={(date) =>
                            setenDate(moment(date).format("YYYY-MM-DD"))
                        }
                        value={enDate}
                        dateFormat="yyyy-MM-dd"
                    />
                    <button
                        style={{ marginLeft: "2%" }}
                        className="btn btn-success"
                        onClick={() => getCount()}
                    >
                        CARI DATA
                    </button>
                </div>
            </div >
            <div className="row  py-4">
                <div className='col-md-6'>
                    <div className='card'>
                        <div className='card-body'>
                            <PelayananHt tahun={2020} loading={loading} dat={{ data1: berkunjung ?? 0, data2: takberkunjung ?? 0 }} />
                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='card'>
                        <div className='card-body'>
                            <Table
                                headers={[
                                    "No",
                                    "Jumlah Berkunjung",
                                    "Jumlah Tidak Berkunjung",
                                    "Total"
                                ]}
                                data={[{ berkunjung: berkunjung, tidak_berkunjung: takberkunjung }]}
                                columnMapper={d => [
                                    d.berkunjung,
                                    d.tidak_berkunjung,
                                    d.tidak_berkunjung + d.berkunjung
                                ]}
                                pagination={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
